import { render } from "./FaqBlock.vue?vue&type=template&id=6ddf6daf&scoped=true&ts=true"
import script from "./FaqBlock.vue?vue&type=script&lang=ts"
export * from "./FaqBlock.vue?vue&type=script&lang=ts"

import "./FaqBlock.vue?vue&type=style&index=0&id=6ddf6daf&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddf6daf"]])

export default __exports__